export class SearchAllSectionQuery {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "emailSearchFilter",
            "baseName": "emailSearchFilter",
            "type": "EmailSearchFilter",
            "format": ""
        },
        {
            "name": "directorySearchFilter",
            "baseName": "directorySearchFilter",
            "type": "DirectorySearchFilter",
            "format": ""
        },
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "DirectoryEntityType",
            "format": ""
        },
        {
            "name": "pageSize",
            "baseName": "pageSize",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return SearchAllSectionQuery.attributeTypeMap;
    }
    constructor() {
    }
}
